import {
  Document,
  Page,
  View,
  Text,
  Image,
  StyleSheet,
  Font,
  Link,
} from '@react-pdf/renderer';

import FSIndustrieCdLight from '../fonts/FSIndustrieCd-Light.ttf';
import FSIndustrieCdMedium from '../fonts/FSIndustrieCd-Medium.ttf';
import FSIndustrieCdBold from '../fonts/FSIndustrieCd-Bold.ttf';
import svg from '../images/certificate-of-sponsorship.png';

export default function PdfCertificate(props) {
  Font.register({
    family: 'FSIndustrieCd',
    src: FSIndustrieCdLight,
    fontStyle: 'normal',
    fontWeight: 300,
  });

  Font.register({
    family: 'FSIndustrieCd',
    src: FSIndustrieCdMedium,
    fontStyle: 'normal',
    fontWeight: 500,
  });

  Font.register({
    family: 'FSIndustrieCd',
    src: FSIndustrieCdBold,
    fontStyle: 'normal',
    fontWeight: 700,
  });

  const styles = StyleSheet.create({
    page: {
      textAlign: 'center',
      padding: 50,
      fontFamily: 'FSIndustrieCd',
      fontWeight: 300,
    },
    bg: {
      position: 'absolute',
      width: '840',
      height: '594',
    },
    certifyTextLine1: {
      fontSize: 18,
      textTransform: 'uppercase',
      marginTop: 190,
      fontWeight: 700,
      letterSpacing: 1.75,
    },
    certifyTextLine2: {
      fontSize: 30,
      marginTop: -5,
      textTransform: 'uppercase',
      fontWeight: 700,
      letterSpacing: 1.5,
    },
    certifyTextLine3: {
      fontSize: 18,
      textTransform: 'uppercase',
      fontWeight: 700,
      letterSpacing: 0.5,
    },
    thankyouText: {
      fontSize: 13,
      fontWeight: 300,
      marginTop: 10,
      width: 460,
      marginLeft: 'auto',
      marginRight: 'auto',
    },
    signatureText: {
      display: 'flex',
      flexDirection: 'column',
      fontSize: 11,
      textTransform: 'uppercase',
      fontWeight: 500,
      position: 'absolute',
      bottom: 135,
      left: -85,
    },
    signatureTextBold: {
      fontSize: 14,
      fontWeight: 700,
      marginBottom: 5,
      letterSpacing: 0.5,
    },
    sloganText: {
      fontSize: 15,
      marginTop: 110,
      fontWeight: 700,
      textTransform: 'uppercase',
      letterSpacing: 1,
    },
    palacesText: {
      fontSize: 10,
      textTransform: 'uppercase',
      fontWeight: 700,
      letterSpacing: 1,
    },
    footer: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      position: 'absolute',
      bottom: 60,
      left: 85,
      right: 85,
      fontSize: 12,
      letterSpacing: 0.5,
    },
    urlText: {
      width: '64%',
      textAlign: 'left',
    },
    stoneNumberText: {
      width: '18%',
      textAlign: 'center',
    },
    wallText: {
      width: '18%',
      textAlign: 'right',
    },
    mediumText: {
      fontWeight: 500,
    },
  });

  return (
    <Document>
      <Page orientation="landscape" wrap={false} style={styles.page}>
        <Image src={svg} style={styles.bg} />
        <Text style={styles.certifyTextLine1}>This is to certify that</Text>
        <Text style={styles.certifyTextLine2}>{props.name}</Text>
        <Text style={styles.certifyTextLine3}>
          Is sponsoring a stone of The White Tower at The Tower of London
        </Text>
        <Text style={styles.thankyouText}>
          Thank you for your support. We are a self-funding charity, privileged
          to be the guardian of six remarkable palaces. Your donation will help
          us give the Tower a future as bright as its past.
        </Text>
        <View style={styles.signatureText}>
          <Text style={styles.signatureTextBold}>
            John Barnes
          </Text>
          <Text>
            PRESIDENT OF HISTORIC ROYAL PALACES, INC
          </Text>
          <Text>
            CHIEF EXECUTIVE OF HISTORICAL ROYAL PALACES
          </Text>
        </View>
        <Text style={styles.sloganText}>Space to stir and be stirred</Text>
        <Text style={styles.palacesText}>
          Tower of London • Hampton Court Palace • Banqueting House
        </Text>
        <Text style={styles.palacesText}>
          Kensington Palace • Kew Palace • Hillsborough Castle and Gardens
        </Text>
        <View style={styles.footer}>
          <Text style={styles.urlText}>
            <Text style={styles.mediumText}>To find your stone visit:</Text>{' '}
            <Link
              src={
                'https://sponsor-a-stone.hrp.org.uk/white-tower/id/' +
                props.stoneId
              }
              style={{ color: '#000', textDecoration: 'none' }}
            >
              sponsor-a-stone.hrp.org.uk/white-tower/id/
              {props.stoneId}
            </Link>
          </Text>
          <Text style={styles.stoneNumberText}>
            <Text style={styles.mediumText}>Stone number:</Text> {props.stoneId}
          </Text>
          <Text style={styles.wallText}>
            <Text style={styles.mediumText}>Wall:</Text> {props.wall} Side Wall
          </Text>
        </View>
      </Page>
    </Document>
  );
}
